import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { Text, useTheme } from 'react-native-paper';
export const Header24 = (props) => {
    const theme = useTheme();
    const styles = StyleSheet.create({
        text: {
            fontSize: 24,
            fontWeight: 'bold',
            lineHeight: 30,
            marginVertical: 2,
            letterSpacing: 0.15,
            color: theme.colors.primary,
        },
    });
    return _jsx(Text, { style: [styles.text, props.style], children: props.children });
};
